export default function formatModifiedDate(date: Date): string {
  return new Intl.DateTimeFormat(["en-GB"], {
    year: "numeric",
    month: "long",
    day: "2-digit"
  })
    .format(new Date(date))
    .replaceAll("/", " ");
}
